import { render, staticRenderFns } from "./send.vue?vue&type=template&id=16f08286&scoped=true&"
import script from "./send.vue?vue&type=script&lang=js&"
export * from "./send.vue?vue&type=script&lang=js&"
import style0 from "./send.vue?vue&type=style&index=0&id=16f08286&prod&scoped=true&lang=scss&"
import style1 from "./send.vue?vue&type=style&index=1&id=16f08286&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f08286",
  null
  
)

export default component.exports